import { CreditsDeduction } from "../../../components/common/Converter";

/**
 * True when dateStr's calendar month is exactly the previous month relative to `now`.
 * Example: now = 2026-07 → only 2026-06 dates pass.
 */
export const isTimesheetDateLastMonth = (dateStr, now = new Date()) => {
  if (!dateStr || !/^\d{4}-\d{2}-\d{2}/.test(String(dateStr))) return false;
  const [y, m] = String(dateStr).slice(0, 10).split("-").map(Number);
  if (!y || !m) return false;
  const prev = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  return y === prev.getFullYear() && m === prev.getMonth() + 1;
};

/**
 * Build leave_card rows for SL/VL amounts actually deducted (withPay pattern).
 */
export const buildLeaveCardsFromCreditDelta = (
  employeeId,
  dateStr,
  beforeByType,
  updatedCredits,
) => {
  const cards = [];
  for (const credit of updatedCredits || []) {
    if (!["Sick Leave", "Vacation Leave"].includes(credit?.type)) continue;
    const before = beforeByType[credit.type] ?? 0;
    const after = parseFloat(credit.current) || 0;
    const deducted = parseFloat((before - after).toFixed(3));
    if (!(deducted > 0)) continue;
    cards.push({
      employee: { id: employeeId },
      leaveType: credit.type,
      withPay: deducted.toFixed(3),
      balance: credit.current,
      startDate: dateStr,
      endDate: dateStr,
      categoryType: "With Pay",
      status: "Approved",
    });
  }
  return cards;
};

/**
 * Apply late/undertime credit deduction when date is last month.
 * Returns { applied, updatedCredits, leaveCards } for callers / tests.
 */
export const applyLateUndertimeCreditDeduction = ({
  employeeId,
  dateStr,
  lateMinutes,
  undertimeMinutes,
  listOfLeave,
  now = new Date(),
}) => {
  if (!isTimesheetDateLastMonth(dateStr, now)) {
    return { applied: false, updatedCredits: [], leaveCards: [] };
  }

  const deductions =
    parseFloat(lateMinutes || 0) + parseFloat(undertimeMinutes || 0);
  if (!(deductions > 0) || !listOfLeave?.length) {
    return { applied: false, updatedCredits: [], leaveCards: [] };
  }

  const beforeByType = Object.fromEntries(
    listOfLeave.map((c) => [c.type, parseFloat(c.current) || 0]),
  );

  const { updatedCredits } = CreditsDeduction(listOfLeave, 0, 0, deductions);
  const leaveCards = buildLeaveCardsFromCreditDelta(
    employeeId,
    dateStr,
    beforeByType,
    updatedCredits,
  );

  return { applied: true, updatedCredits, leaveCards };
};
